export default class SwiperSlider {

	constructor(swiper) {
		if (!swiper) return;

		const params = {
			loop: true,
			autoplay: true,
			parallax: true,
			speed: 1000,
			pagination: {
				clickable: true,
				el: '.swiper-pagination',
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		}

		Object.assign(swiper, params)

		swiper.initialize();

	}
}
